//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
/** Components */
import { AIM_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import useDelete from '../../../../hooks/useDelete';
//#endregion

function AIM_BASICF() {
  //#region 변수
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );

  //#region 그리드 변수
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const [currentRowIndex1, setCurrentRowIndex1] = useState(null);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);

  const gridRef1 = useRef(); // 보이스 체크 그리드

  const getDeletePayload1 = (rows) =>
    rows.map((row) => ({
      procedureName: 'SP_AIM_BASIC_D1',
      _CUST_CD: Commons.EncryptAES(row.custCd) || '', //사업장코드
      _AI_MESSAGE_CD: Commons.EncryptAES(row.AI_MESSAGE_CD) || '', //보이스 체크 코드
    }));

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    getDeletePayload: getDeletePayload1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  //#region 테이블 변수
  const [changedTableData1, setChangedTableData1] = useState(new Map());

  const [inputs, setInputs] = useState({
    errorAimsgCd: '', // 비정상 응답 코드
    errorMsg: '', // 비정상 응답 메시지
    errorSeq: '', // 비정상 응답 SEQ
    errorGubun: '', // 비정상 응답 구분
    endAimsgCd: '', // 비정상 응답 코드
    endMsg: '', // 종료 문장 메시지
    endSeq: '', // 종료 문장 SEQ
    endGubun: '', // 종료 문장 구분
  });

  const tableData1 = [
    {
      cells: [
        {
          gubun: 'R',
          content: '비정상 응답',
        },
        {
          // 비정상 응답 메시지
          gubun: 'I',
          type: 'input',
          value: inputs.errorMsg ? inputs.errorMsg : '',
          isRequired: true, // 필수 입력 지정
          colSpan: 4,
          onChange: (e) => {
            const fieldName = 'errorMsg';
            const newValue = e.target.value;

            setInputs((prev) => ({ ...prev, [fieldName]: newValue }));

            setChangedTableData1((prevMap) => {
              const newMap = new Map(prevMap);
              newMap.set(fieldName, newValue);
              return newMap;
            });
          },
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '종료 문장',
        },
        {
          // 종료 문장 메시지
          gubun: 'I',
          type: 'input',
          value: inputs.endMsg ? inputs.endMsg : '',
          isRequired: true, // 필수 입력 지정
          colSpan: 4,
          onChange: (e) => {
            const fieldName = 'endMsg';
            const newValue = e.target.value;

            setInputs((prev) => ({ ...prev, [fieldName]: newValue }));

            setChangedTableData1((prevMap) => {
              const newMap = new Map(prevMap);
              newMap.set(fieldName, newValue);
              return newMap;
            });
          },
        },
      ],
    },
  ];
  //#endregion

  //조회조건
  const searchRef = useRef({
    custList: custInfo.map((item) => ({
      value: item.CUST_CD,
      name: item.CUST_NM,
    })),
    custCd: custInfo?.[0]?.CUST_CD ?? null,
    searchText: '',
  });

  // const colWidth = ["20%", "30%", "20%", "30%"];

  useEffect(() => {
    Init();
  }, []);

  //#endregion
  const Init = async () => {
    await SearchLogic1();
    await SearchLogic2();
  };
  //#region 조회

  //그리드 조회
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_AIM_BASIC_R1',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd),
            _searchText: Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
          },
        ]
      ).then((result) => {
        // 조회시 기존 changeRowData 초기화
        // setChangedRowData1([]);
        setChangedTableData1(new Map());

        let data = result.data;
        if (data.length == 0) {
          setRowData1([]);

          dispatch(
            showSnackbar({
              message:
                lanInfo.length === 0
                  ? ''
                  : lanInfo.find(
                      (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NotData'
                    ).LAN_NM,
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          setRowData1(Commons.InsertNumber(data));
          ResetLogic();
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  //공통 조회(_value1:사업장코드)
  const SearchLogic2 = async () => {
    setLoading(true);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_AIM_BASIC_R2',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd),
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length == 0) {
          // 데이터가 없을 경우 비정상 응답 / 종료 문장 빈값 초기화
          setInputs((prevState) => ({
            ...prevState,
            errorMsg: '',
            endMsg: '',
          }));
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          const result = {
            // 종료 문장
            endAimsgCd: '',
            endMsg: '',
            endSeq: '',
            endGubun: '',
            // 비정상 응답
            errorAimsgCd: '',
            errorMsg: '',
            errorSeq: '',
            errorGubun: '',
          };

          // 구분 - 마지막 : 0 , 에러 : 1 ,  질문 : 2
          data.forEach((item) => {
            if (item.GUBUN === '0') {
              result.endAimsgCd = item.AI_MESSAGE_CD;
              result.endMsg = item.MESSAGE;
              result.endSeq = item.SEQ;
              result.endGubun = item.GUBUN;
            } else if (item.GUBUN === '1') {
              result.errorAimsgCd = item.AI_MESSAGE_CD;
              result.errorMsg = item.MESSAGE;
              result.errorSeq = item.SEQ;
              result.errorGubun = item.GUBUN;
            }
          });

          setInputs((prev) => ({
            ...prev,
            ...result,
          }));
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장
  //저장버튼 클릭 시 함수()
  const SaveLogic1 = async () => {
    setLoading(true);

    try {
      const hasDelete = deletedRowData1.length > 0;

      const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      const rowHasChange = changedRows.length > 0;

      const changedTablesKey = [...changedTableData1.keys()];
      const tableHasChange = changedTableData1.size > 0;

      // 조건 : Grid & Form 데이터가 삭제/변경된 항목이 없을 경우
      if (!hasDelete && !rowHasChange && !tableHasChange) {
        dispatch(
          showSnackbar({
            message: '저장할 데이터가 없습니다.',
            type: 'warning',
          })
        );

        return;
      }

      // 조건 : Grid 데이터가 변경된 경우
      if (rowHasChange) {
        const invalidRows = changedRows.filter(
          (item) => !item.MESSAGE || !item.MESSAGE.trim()
        );
        if (invalidRows.length > 0) {
          dispatch(
            showSnackbar({
              message: '메세지는 필수 입력 항목입니다.',
              type: 'error',
            })
          );
          return;
        }
      }

      // 조건 : Grid 데이터가 삭제된 경우
      if (hasDelete) {
        try {
          await deleteHandler1.DeleteLogic();
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }

      // 조건 : Grid 데이터가 변경이 있을경우 저장
      const saveData = [];

      if (rowHasChange) {
        // 그리드 데이터 저장
        changedRows.forEach((item) => {
          saveData.push({
            procedureName: 'SP_AIM_BASIC_U1',
            _AI_MESSAGE_CD:
              item.AI_MESSAGE_CD === undefined
                ? ''
                : Commons.EncryptAES(item.AI_MESSAGE_CD) || '',
            _MESSAGE:
              item.MESSAGE === undefined
                ? ''
                : Commons.EncryptAES(item.MESSAGE) || '',
            _ORG_SEQ:
              item.SEQ === undefined
                ? ''
                : Commons.EncryptAES(item.SEQ.toString()) || '',
            _CHANGE_SEQ:
              item.no === undefined
                ? ''
                : Commons.EncryptAES(item.no.toString()) || '',
            _GUBUN: Commons.EncryptAES(item.GUBUN) || '',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '',
            _USER_ID: userInfo.userid || '',
          });
        });
      }

      // 조건 : Form 데이터에 변경이 있을경우 저장
      if (tableHasChange) {
        // Form 데이터 저장
        changedTablesKey.forEach((item) => {
          const fieldMap = {
            errorMsg: {
              _AI_MESSAGE_CD: inputs.errorAimsgCd,
              _MESSAGE: inputs.errorMsg,
              _SEQ: inputs.errorSeq?.toString(),
              _GUBUN: inputs.errorGubun,
            },
            endMsg: {
              _AI_MESSAGE_CD: inputs.endAimsgCd,
              _MESSAGE: inputs.endMsg,
              _SEQ: inputs.endSeq?.toString(),
              _GUBUN: inputs.endGubun,
            },
          };

          const current = fieldMap[item] || {};

          saveData.push({
            procedureName: 'SP_AIM_BASIC_U2',
            _AI_MESSAGE_CD: Commons.EncryptAES(current._AI_MESSAGE_CD || ''),
            _MESSAGE: Commons.EncryptAES(current._MESSAGE || ''),
            _SEQ: Commons.EncryptAES(current._SEQ || ''),
            _GUBUN: Commons.EncryptAES(current._GUBUN || ''),
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd || ''),
            _USER_ID: userInfo.userid || '',
          });
        });
      }

      // 저장할 데이터가 있을경우 저장
      if (saveData.length > 0) {
        try {
          const result = await Commons.Axios(
            'post1',
            Global.base.useUrl + Global.urls.Execute.execute,
            saveData
          );
          const data = result.data;

          if (data.length === 0) {
            dispatch(
              showSnackbar({
                message: '저장 후 반환된 값이 없습니다.',
                type: 'error',
              })
            );
            return;
          } else if (data?.[0]?.type === 'Error') {
            dispatch(
              showSnackbar({
                message: data[0].message || '에러가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else {
          }
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }

      /* SEQ 순서 재정렬 프로시저 별도 실행 - START */
      const reorderResult = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_AIM_BASIC_U3',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd || ''),
          },
        ]
      );
      const reorderData = reorderResult.data;

      if (reorderData.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장 후 반환된 값이 없습니다.',
            type: 'error',
          })
        );
        return;
      } else if (reorderData?.[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: reorderData[0].message || '순서 재정렬 중 에러 발생',
            type: 'error',
          })
        );
        return;
      } else {
      }
      /* SEQ 순서 재정렬 프로시저 별도 실행 - END */

      // 성공 메시지
      if (hasDelete && (rowHasChange || tableHasChange)) {
        dispatch(
          showSnackbar({
            message: '저장 및 삭제가 완료되었습니다.',
            type: 'success',
          })
        );
      } else if (hasDelete) {
        dispatch(
          showSnackbar({
            message: '삭제되었습니다.',
            type: 'warning',
          })
        );
      } else if (rowHasChange || tableHasChange) {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
      }

      const api = gridRef1.current.api;
      api.deselectAll();

      await SearchLogic1();
      await SearchLogic2();
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    setCurrentRowIndex1(rowIndex);
    setSelectedRowData1([rowData]);
  };
  const ResetLogic = () => {
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
  };

  const HandleAddClick = async (_gridRef) => {
    if (_gridRef) {
      const api = _gridRef.current.api;

      // const rowCount = api.paginationGetRowCount(); // 현재 행 개수 확인 (페이지)
      const rowCount = api.getDisplayedRowCount(); // 현재 행 개수 확인 (화면)
      const newNo = rowCount + 1;

      const newRow = {
        custCd: '', //사업장코드
        MESSAGE: '', // 보이스 체크 내용
        no: newNo, //필수값
        newYn: 'Y', //필수값
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: newNo,
      });
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <AIM_BASIC
        gridId1={'grid1'}
        inputs={inputs}
        setInputs={setInputs}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setCurrentRowIndex1={setCurrentRowIndex1}
        tableData1={tableData1}
        gridRef1={gridRef1}
        searchRef={searchRef}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        // 함수
        SearchLogic1={SearchLogic1}
        SearchLogic2={SearchLogic2}
        SaveLogic1={SaveLogic1}
        HandleAddClick={HandleAddClick}
        ResetLogic={ResetLogic}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
      />
      <Loading open={loading} />
    </div>
  );
}

export default AIM_BASICF;
